import { mixins, styled } from '@bob/library'

export const Wrapper = styled.div`
  background: ${mixins.colors.corporateYellow};
  height: 26px;
  position: relative;
  overflow: hidden;

  @media print {
    display: none;
  }
`

export interface CTAWrapperProps {
  'data-top': string
}

export const CTAWrapper = styled.div<CTAWrapperProps>`
  ${mixins.typography.subtitleSmall};
  position: absolute;
  left: 0;
  right: 0;
  top: ${(p: CTAWrapperProps) => p['data-top']};
  transition: 1s;
`

export const CTA = styled.a`
  text-align: center;
  display: block;
`
